"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateReason = exports.UpdateStatus = void 0;
/**
 * The enum for `update_status` property of `Address` data.
 */
var UpdateStatus;
(function (UpdateStatus) {
    /**
     * The record is not modified.
     */
    UpdateStatus[UpdateStatus["NONE"] = 0] = "NONE";
    /**
     * The record is modified.
     */
    UpdateStatus[UpdateStatus["UPDATED"] = 1] = "UPDATED";
    /**
     * The record is marked as no longer valid.
     */
    UpdateStatus[UpdateStatus["ABOLISHED"] = 2] = "ABOLISHED";
})(UpdateStatus = exports.UpdateStatus || (exports.UpdateStatus = {}));
/**
 * The enum for `update_reason` property of `Address` data.
 */
var UpdateReason;
(function (UpdateReason) {
    /**
     * The record is not modified.
     */
    UpdateReason[UpdateReason["NONE"] = 0] = "NONE";
    /**
     * The city where the area to which this record was assigned previously belongs
     * was merged with other cities.
     */
    UpdateReason[UpdateReason["REDESIGNATED"] = 1] = "REDESIGNATED";
    /**
     * The district to which this record is assigned had gone through address
     * reorganization, such as designation as a building-based addressing area.
     */
    UpdateReason[UpdateReason["ADDRESSING_SYSTEM_RENEWAL"] = 2] = "ADDRESSING_SYSTEM_RENEWAL";
    /**
     * The district to which this record is assigned had gone through area
     * reorganization.
     */
    UpdateReason[UpdateReason["READJUSTMENT"] = 3] = "READJUSTMENT";
    /**
     * The area or its districts weren't changed, but the postal codes
     * were reassigned.
     */
    UpdateReason[UpdateReason["REASSIGNMENT"] = 4] = "REASSIGNMENT";
    /**
     * The record contained some errors and was amended.
     */
    UpdateReason[UpdateReason["AMENDMENT"] = 5] = "AMENDMENT";
    /**
     * The record is marked as no longer valid.
     */
    UpdateReason[UpdateReason["ABOLISHED"] = 6] = "ABOLISHED";
})(UpdateReason = exports.UpdateReason || (exports.UpdateReason = {}));
